<template>
    <div class="row align-items-center mt-6" v-loading="loading">
        <div class="col-sm-12 col-md-12 mb-4">
            <el-form ref="formOficial" :model="formOficial" class="col-md-8 offset-md-2" status-icon :rules="rules" label-position="left">
                <div class="d-flex align-items-center mb-5" v-if="!modalEdit">
                    <span class="label label-success label-inline mr-2" style="font-size: 1rem;">Oficial</span>
                    <h3 class="text-dark font-weight-bold mb-0">{{currentAcreditation.athlete}}</h3>
                </div>
                <el-form-item label="Función" class="mb-5" prop="idfunction">
                    <el-select v-model="formOficial.idfunction" placeholder="Seleccionar" size="small" class="w-50">
                        <el-option v-for="item in listFunction" :key="item.idfunction" :label="item.name" :value="item.idfunction"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-divider class="my-4"></el-divider>
            <div v-if="modalEdit">
                <div class="btn btn-sm btn-success mr-3" @click="updateOfficer('formOficial')"><i class="el-icon-edit"></i> Actualizar</div>
                <div class="btn btn-sm btn-secondary" @click="cancelEdit"><i class="el-icon-close"></i> Cerrar</div>
            </div>
            <div v-else>
                <div class="btn btn-sm btn-success mr-3"  @click="submitOfficer('formOficial')"><i class="el-icon-arrow-right"></i> Siguiente</div>
                <div class="btn btn-sm btn-secondary" @click="cancelProcess"><i class="el-icon-close"></i> Cancelar</div>
            </div>

        </div>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import code from "@/core/config/status.code";
import { STEP, MODAL_NEW, MODAL_EDIT } from "@/store/step.module";
import { OFFICERS_FUNCTIONS, OFFICERS_REGISTER, OFFICERS_LIST } from "@/store/acreditation.module";
//services
import acrService from '@/core/services/acr.service';

export default {
    props: {
        academicdata: {
            type: Object,
            default: () => {}
        },
    },
    data: () => ({
        loading: false,
        listFunction: [],
        formOficial:{
            idfunction: null
        },
        rules: {
            idfunction: [{required: true,message: 'Seleccione una función',trigger: ['change', 'blur']}],
        }
    }),
    computed: {
        ...mapGetters(["currentAcreditation", "modalEdit"])
    },
    beforeMount(){
        if(this.modalEdit){
            return this.formOficial = this.academicdata;
        } 
    },
    methods:{
        cancelProcess(){
            this.$store.dispatch(MODAL_NEW, false);
        },
        cancelEdit(){
            this.$store.dispatch(MODAL_EDIT, false);
        },
        getFunctions(){
            try {
                this.loading = true;
                this.$store.dispatch(OFFICERS_FUNCTIONS, this.currentAcreditation)
                    .then((data) => {
                        this.listFunction = data;
                        this.loading = false;
                })
                .catch((err) => {
                    this.loading = false;
                    this.$alert( err.data !='' ? err.data.messages.error : err.statusText, 'Lo sentimos, error: ' + err.status, {
                        type: 'error',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(err.status, 'athlete');
                        }
                    });
                })    
            } catch (error) {
                this.loading = false;
                this.$notify.error({title: 'Error:', message: error});
            }
        },
        submitOfficer(formName){
            this.$refs[formName].validate((valid) => {
                if (!valid) 
                    return false;

                try {
                    this.loading = true;
                    this.$store.dispatch(OFFICERS_REGISTER, {"acrd": this.currentAcreditation, "officer": this.formOficial})
                    .then(() => {
                        this.$store.dispatch(OFFICERS_LIST, this.currentAcreditation)
                        .then(() => {
                            this.$store.dispatch(STEP, 3);
                            this.loading = false;
                        })
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.$alert( err.data !='' ? err.data.messages.error : err.statusText, 'Error ' + err.status, {
                            type: 'error',
                            confirmButtonText: 'Entendido',
                            callback: action => {
                               code.Manager(err.status);
                            }
                        });
                    });
                } catch (error) {
                    this.loading = false;
                    this.$notify.error({title: 'Error:', message: error});
                }
            });
        },
        updateOfficer(formName){
            this.$refs[formName].validate(async ( valid) => {
                if (!valid) 
                    return false;

                try {
                    this.loading = true;
                    const res = await acrService.updateOfficer({slug: this.formOficial.idacreditation, data: this.formOficial});
                    this.loading = false;
                    this.$notify.success({title: 'Perefcto', message: res.data.message});
                    //falta que actialice la tabla nada más :) ya será para otro día
                } catch (e) {
                    this.loading = false;
                    if (e instanceof acrError) {
                        this.$alert( e.message.data !='' ? e.message.data.messages.error : e.message.statusText, 'Error ' +  e.errorCode, {
                            type: 'warning',
                            confirmButtonText: 'Entendido',
                            callback: action => {
                                code.Manager(e.errorCode, 'athlete');
                            }
                        });
                    }
                }
            });
        }
    },
    created(){
        this.getFunctions();
    }
}
</script>